import {
  types,
  GET_CONFIGURATION,
  GET_CONFIGURATION_SUCCESS,
  GET_CONFIGURATION_ERROR,
} from './types';

const initialState = {
  unauthorized: null,
  configuration: {
    NumberOfPreviousTimeEntryMonthsAllowed: 0,
    isLoading: false,
    isError: false,
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case types.UNAUTHORIZED:
      return {
        ...state,
        unauthorized: true,
      };
    case types.AUTHORIZED:
      return {
        ...state,
        unauthorized: false,
      };
    case GET_CONFIGURATION:
      return {
        ...state,
        configuration: {
          ...state.configuration,
          isLoading: true,
          isError: false,
        },
      };
    case GET_CONFIGURATION_SUCCESS:
      return {
        ...state,
        configuration: {
          isError: false,
          isLoading: false,
          NumberOfPreviousTimeEntryMonthsAllowed:
            action.payload.NumberOfPreviousTimeEntryMonthsAllowed,
        },
      };
    default:
      return state;
  }
};
